import { useSelector } from "react-redux"
import { AppDispatch, RootState } from "../../store/store"
import { Navigate, useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { fetchRoles, fetchToken, loginUser, sessionTimeout } from "../../store/authSlice"

const ProtectedRoute = ({ children, requiredRoles }: { children: JSX.Element, requiredRoles: String[] }) => {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const idToken = useSelector((state: RootState) => state.auth.idToken)
    const roles = useSelector((state: RootState) => state.auth.roles)
    const isLoading = useSelector((state: RootState) => state.auth.loading)

    useEffect(() => {

        const authenticateUser = async () => {
            try {

                await dispatch(fetchToken()).unwrap();
                await dispatch(fetchRoles()).unwrap();
            }
            catch (error) {
                if (error === 'No accounts found') {
                    await dispatch(loginUser())
                }
                else {
                    dispatch(sessionTimeout(true))
                }
            }
        }
        if (!idToken) {
            authenticateUser()
        }

    }, [dispatch, navigate, idToken, roles])

    if (isLoading || !idToken || !roles.length) {
        return (<div className="page-not-input">
            <h1 className="color">Loading..</h1>
            <span className="text-spacing">Please wait while we set up your access</span>
        </div>)
    }
    if (!idToken) return <Navigate to="/" />;

    // If the route is /help, allow access if the user has at least one of the required roles
    if (requiredRoles.includes('help')) {
        const hasAnyRole = roles.some(role => ['idm', 'dg', 'benchmarking'].includes(role));
        if (hasAnyRole) {
            return children;
        }

    }

    // Standard role check for other pages   
    if (!roles.some((role) => requiredRoles.includes(role))) {
        return <Navigate to="/unauthorized" />;
    }

    return children;
}

export default ProtectedRoute;